import React from 'react';
import { Container, Row, Col } from 'reactstrap'
import ClientStaffDetail from '../../Editors/ClientStaffDetail';



const MoveDepartmentToStaff = () => <React.Fragment>
    <Container>
        <Row>
            <Col>
                <ClientStaffDetail />
            </Col>
        </Row>
    </Container>
</React.Fragment>


export default MoveDepartmentToStaff;